import React, { PureComponent } from 'react';
import Table from './table';
import TimeAndSaleBUSD from './TimeAndSaleBUSD';

class RightContent extends PureComponent {
  getWidth = () => {
    const { width } = this.props;

    return width - 50; // minus padding
  };

  render() {
    const { tableHeight, width, isChart } = this.props;
    return (
      <div className="ts-table d-flex flex-fill h-100" style={{ width }}>
        {isChart ? (
          <TimeAndSaleBUSD width={this.getWidth()} />
        ) : (
          <Table height={tableHeight} />
        )}
      </div>
    );
  }
}

RightContent.propTypes = {};

export default RightContent;
